import { obterRequisicoesAsync} from "../../services/requisicaoServicoService";

const atualizarRequisicoesServico = async ({ commit }) => {
    const requisicoesServico = await obterRequisicoesAsync();
    commit('atualizarRequisicoesServico', requisicoesServico);
}

const atualizarRequisicaoServico = ({ commit }, requisicaoServico) => {
    commit('atualizarRequisicaoServico', requisicaoServico);
}

const addRequisicaoServico = ({ commit }, requisicaoServico) => {
    commit('addRequisicaoServico', requisicaoServico);
}

const updateRequisicaoServico = ({ commit }, requisicaoServico) => {
    commit('updateRequisicaoServico', requisicaoServico);
}

export default {
    atualizarRequisicoesServico,
    atualizarRequisicaoServico,
    addRequisicaoServico,
    updateRequisicaoServico
}